export default "__VITE_ASSET__0a45b98d__"